import { render, staticRenderFns } from "./AssignationMail.vue?vue&type=template&id=03e2db2e&scoped=true"
import script from "./AssignationMail.vue?vue&type=script&lang=js"
export * from "./AssignationMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2db2e",
  null
  
)

export default component.exports